import {Option} from 'platform/components';

import {isNil} from 'ramda';

import {GetCodeListResponse} from '@dms/api/warehouse';

import {Nullish} from 'shared/web';

export const getOptionsFromCodeList = (codeLists: GetCodeListResponse | Nullish): Option[] => {
  if (isNil(codeLists)) {
    return [];
  }

  return codeLists.map((codeLists) => ({
    label: codeLists.name,
    value: codeLists.code,
  }));
};
